import { differenceInCalendarDays, endOfDay, startOfDay, subDays } from "date-fns";

export function previousReviewPeriod(range) {
  const from = startOfDay(range.from);
  const days = differenceInCalendarDays(range.to, from) + 1;
  return { from: subDays(from, days), to: endOfDay(subDays(from, 1)) };
}

export function reviewResponseRate(stats) {
  if (!stats || !stats.total_reviews) return null;
  return Math.round(100 * Math.max(0, stats.total_reviews - stats.pending_replies) / stats.total_reviews);
}

export function metricChange(current, previous, { points = false, lowerIsBetter = false } = {}) {
  if (current == null || previous == null) return { text: "No comparison available", tone: "muted" };
  if (current === previous) return { text: "No change vs previous period", tone: "muted" };
  if (!points && previous === 0) return { text: "No previous activity to compare", tone: "muted" };
  const change = points ? current - previous : ((current - previous) / previous) * 100;
  const rounded = Number(change.toFixed(1));
  return {
    text: `${change > 0 ? "+" : ""}${rounded}${points ? " pts" : "%"} vs previous period`,
    tone: (change > 0) !== lowerIsBetter ? "good" : "caution",
  };
}

export function fillReviewDays(rows = [], range) {
  const byDate = new Map(rows.map(row => [row.date, row.count]));
  const days = differenceInCalendarDays(range.to, range.from) + 1;
  return Array.from({ length: Math.max(0, days) }, (_, index) => {
    const day = subDays(range.to, days - index - 1);
    const key = `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, "0")}-${String(day.getDate()).padStart(2, "0")}`;
    return { date: key, count: byDate.get(key) || 0 };
  });
}
